import React, { Component } from "react";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  Card,
  CardBody,
  CardTitle,
  Container,
  Table,
  Input,
  Button,
  Row,
  Col,
  Label,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import Loader from "../../components/Common/Loader";
import {
  getDataRetentionPolicies,
  updateDataRetentionPolicy,
  getDataRetentionSettings,
  updateDataRetentionSettings,
} from "../../store/actions";

class DataRetentionPolicies extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("authUser")),
      policies: null,
      editedPolicies: {},
      settings: null,
      editedSettings: {},
      showSuccess: false,
      showError: false,
      alertMessage: "",
    };
  }

  componentDidMount() {
    this.props.getDataRetentionPolicies(this.state.user);
    this.props.getDataRetentionSettings(this.state.user);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.loadingGetDataRetentionPolicies === false &&
      prevProps.loadingGetDataRetentionPolicies === true
    ) {
      this.setState({
        policies: this.props.dataRetentionPolicies,
        editedPolicies: {},
      });
    }
    if (
      this.props.loadingGetDataRetentionSettings === false &&
      prevProps.loadingGetDataRetentionSettings === true
    ) {
      this.setState({
        settings: this.props.dataRetentionSettings,
        editedSettings: {},
      });
    }
    if (
      this.props.loadingUpdateDataRetentionPolicy === false &&
      prevProps.loadingUpdateDataRetentionPolicy === true
    ) {
      if (this.props.errorUpdateDataRetentionPolicy) {
        this.setState({ showError: true, alertMessage: this.props.t("Error al guardar la política") });
      } else {
        this.setState({ showSuccess: true, alertMessage: this.props.t("Política actualizada") });
        this.props.getDataRetentionPolicies(this.state.user);
      }
    }
    if (
      this.props.loadingUpdateDataRetentionSettings === false &&
      prevProps.loadingUpdateDataRetentionSettings === true
    ) {
      if (this.props.errorUpdateDataRetentionSettings) {
        this.setState({ showError: true, alertMessage: this.props.t("Error al guardar la configuración") });
      } else {
        this.setState({ showSuccess: true, alertMessage: this.props.t("Configuración actualizada") });
        this.props.getDataRetentionSettings(this.state.user);
      }
    }
  }

  handlePolicyFieldChange(id, field, value) {
    this.setState((prevState) => ({
      editedPolicies: {
        ...prevState.editedPolicies,
        [id]: {
          ...prevState.editedPolicies[id],
          [field]: value,
        },
      },
    }));
  }

  getPolicyValue(policy, field) {
    const edited = this.state.editedPolicies[policy.id];
    if (edited && edited[field] !== undefined) return edited[field];
    return policy[field];
  }

  savePolicy(policy) {
    this.props.updateDataRetentionPolicy(this.state.user, policy.id, {
      months_online: parseInt(this.getPolicyValue(policy, "months_online"), 10),
      months_history: parseInt(this.getPolicyValue(policy, "months_history"), 10),
      batch_size: parseInt(this.getPolicyValue(policy, "batch_size"), 10),
      enabled: this.getPolicyValue(policy, "enabled") ? 1 : 0,
    });
  }

  handleSettingsFieldChange(field, value) {
    this.setState((prevState) => ({
      editedSettings: { ...prevState.editedSettings, [field]: value },
    }));
  }

  getSettingsValue(field) {
    if (this.state.editedSettings[field] !== undefined) return this.state.editedSettings[field];
    return this.state.settings ? this.state.settings[field] : "";
  }

  saveSettings() {
    this.props.updateDataRetentionSettings(this.state.user, {
      dataRetentionIntervalHours: parseInt(this.getSettingsValue("dataRetentionIntervalHours"), 10),
      logRetentionDays: parseInt(this.getSettingsValue("logRetentionDays"), 10),
    });
  }

  render() {
    if (!this.state.policies || !this.state.settings) {
      return (
        <React.Fragment>
          <div className="loaderCenter">
            <Loader></Loader>
          </div>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Card>
              <CardBody>
                <CardTitle>{this.props.t("Retención y purga de datos")}</CardTitle>
                <p className="text-muted">
                  {this.props.t(
                    "Archivado y purga automática de tasklist, logs_callbacks y callbacks. Los cambios se recogen en el siguiente ciclo del planificador, sin necesidad de reiniciar."
                  )}
                </p>
                <div className="table-responsive">
                  <Table className="table-centered table-nowrap mb-0">
                    <thead className="thead-light">
                      <tr>
                        <th>{this.props.t("Tabla")}</th>
                        <th>{this.props.t("Meses online")}</th>
                        <th>{this.props.t("Meses histórico")}</th>
                        <th>{this.props.t("Tamaño lote")}</th>
                        <th>{this.props.t("Activada")}</th>
                        <th>{this.props.t("Última ejecución")}</th>
                        <th>{this.props.t("Resultado")}</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.policies.map((policy) => (
                        <tr key={policy.id}>
                          <td>{policy.table_name}</td>
                          <td>
                            <Input
                              type="number"
                              min="0"
                              value={this.getPolicyValue(policy, "months_online")}
                              onChange={(e) =>
                                this.handlePolicyFieldChange(policy.id, "months_online", e.target.value)
                              }
                            />
                          </td>
                          <td>
                            <Input
                              type="number"
                              min="0"
                              value={this.getPolicyValue(policy, "months_history")}
                              onChange={(e) =>
                                this.handlePolicyFieldChange(policy.id, "months_history", e.target.value)
                              }
                            />
                          </td>
                          <td>
                            <Input
                              type="number"
                              min="1"
                              value={this.getPolicyValue(policy, "batch_size")}
                              onChange={(e) =>
                                this.handlePolicyFieldChange(policy.id, "batch_size", e.target.value)
                              }
                            />
                          </td>
                          <td className="text-center">
                            <div className="d-flex justify-content-center">
                              <Input
                                type="checkbox"
                                checked={!!Number(this.getPolicyValue(policy, "enabled"))}
                                onChange={(e) =>
                                  this.handlePolicyFieldChange(policy.id, "enabled", e.target.checked)
                                }
                              />
                            </div>
                          </td>
                          <td>{policy.last_run_at || "-"}</td>
                          <td>
                            {policy.last_run_status === "ERROR" ? (
                              <span className="text-danger" title={policy.last_run_error || ""}>
                                {this.props.t("Error")}
                              </span>
                            ) : policy.last_run_status === "OK" ? (
                              <span className="text-success">
                                {this.props.t("archivadas")}: {policy.last_run_archived} / {this.props.t("purgadas")}:{" "}
                                {policy.last_run_purged}
                              </span>
                            ) : (
                              "-"
                            )}
                          </td>
                          <td>
                            <Button color="secondary" size="sm" onClick={() => this.savePolicy(policy)}>
                              {this.props.t("Guardar")}
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </CardBody>
            </Card>

            <Card>
              <CardBody>
                <CardTitle>{this.props.t("Configuración general")}</CardTitle>
                <Row>
                  <Col md={4}>
                    <Label>{this.props.t("Frecuencia del mantenimiento (horas)")}</Label>
                    <Input
                      type="number"
                      min="1"
                      value={this.getSettingsValue("dataRetentionIntervalHours")}
                      onChange={(e) => this.handleSettingsFieldChange("dataRetentionIntervalHours", e.target.value)}
                    />
                  </Col>
                  <Col md={4}>
                    <Label>{this.props.t("Retención de logs en disco (días)")}</Label>
                    <Input
                      type="number"
                      min="1"
                      value={this.getSettingsValue("logRetentionDays")}
                      onChange={(e) => this.handleSettingsFieldChange("logRetentionDays", e.target.value)}
                    />
                  </Col>
                </Row>
                <p className="text-muted mt-2">
                  {this.props.t("Última ejecución del mantenimiento")}: {this.state.settings.dataRetentionLastRunAt || "-"}
                </p>
                <Button color="secondary" onClick={() => this.saveSettings()}>
                  {this.props.t("Guardar")}
                </Button>
              </CardBody>
            </Card>
          </Container>
        </div>

        {this.state.showSuccess && (
          <SweetAlert
            success
            title={this.state.alertMessage}
            confirmBtnBsStyle="success"
            confirmBtnText={this.props.t("ok")}
            onConfirm={() => this.setState({ showSuccess: false })}
          ></SweetAlert>
        )}
        {this.state.showError && (
          <SweetAlert
            danger
            title={this.state.alertMessage}
            confirmBtnBsStyle="danger"
            confirmBtnText={this.props.t("ok")}
            onConfirm={() => this.setState({ showError: false })}
          ></SweetAlert>
        )}
      </React.Fragment>
    );
  }
}

const mapStateProps = (state) => {
  const { loadingGetDataRetentionPolicies, dataRetentionPolicies } = state.getDataRetentionPolicies;
  const { loadingUpdateDataRetentionPolicy, errorUpdateDataRetentionPolicy } = state.updateDataRetentionPolicy;
  const { loadingGetDataRetentionSettings, dataRetentionSettings } = state.getDataRetentionSettings;
  const { loadingUpdateDataRetentionSettings, errorUpdateDataRetentionSettings } = state.updateDataRetentionSettings;
  return {
    loadingGetDataRetentionPolicies,
    dataRetentionPolicies,
    loadingUpdateDataRetentionPolicy,
    errorUpdateDataRetentionPolicy,
    loadingGetDataRetentionSettings,
    dataRetentionSettings,
    loadingUpdateDataRetentionSettings,
    errorUpdateDataRetentionSettings,
  };
};

export default withRouter(
  connect(mapStateProps, {
    getDataRetentionPolicies,
    updateDataRetentionPolicy,
    getDataRetentionSettings,
    updateDataRetentionSettings,
  })(withNamespaces()(DataRetentionPolicies))
);
